module.exports = __webpack_public_path__ + "img/icon-couponbg.70f72918.png";